import { Select } from 'antd'
import { useRouter } from 'next/router'
import { useGetUnfilteredServicesQuery } from '../../../redux/apiSlice'
import useTranslation from '@/hooks/useTranslation'

import Arrow from '../../svgs/formBuild/ArrowDown.js'

const { Option } = Select

export default function SelectServices({ onChange, allExist, slug }) {
  const router = useRouter()
  const { t } = useTranslation()

  const { data } = useGetUnfilteredServicesQuery({ locale: router.locale })

  return (
    <div>
      <label className='capitalize' htmlFor='service'>
        {t('table.filter.service')}
      </label>
      <Select
        id='service'
        showSearch
        placeholder={t('table.filter.ph.service')}
        suffixIcon={<Arrow style='w-14' />}
        onChange={(val, option) => {
          if (slug) {
            onChange(option.slug, option.isPrepaid)
          } else {
            onChange(val)
          }
        }}
        filterOption={(input, option) =>
          option.children
            .toString()
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        }
      >
        {allExist && <Option value={null}>{t('All')}</Option>}
        {data?.map((ele) => (
          <Option
            key={ele.id}
            value={ele.id}
            slug={ele.slug}
            isPrepaid={ele.is_prepaid === 1}
          >
            {ele.title}
          </Option>
        ))}
      </Select>
    </div>
  )
}
